module.exports = __webpack_public_path__ + "img/es.d005550.svg";